import styled from 'styled-components';
import { Message } from '../Styles';

export const StyledMessage = styled(Message)`
  margin-left: 5px;
  width: 92%;
  &::before {
    content: '';
    position: absolute;
    bottom: -6px;
    border-top: 6px solid #D7D8D8;
    left: 0;
    border-right: 7px solid transparent;
  }
  background: ${(props) => props.isSeller && '#BFBCAC'};
`;


export const MessageText = styled.div`
  //font-size: ${(props) => (props.zoomLevel < 1 ? '1.5em' : '1.2em')};
  font-size: ${(props) => (props.zoomLevel < 1 && props.chatFontSize > 0 ? `${1.5 + Number(`.${props.chatFontSize}`)}em` : `${1.2 + Number(`.${props.chatFontSize}`)}em`)};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  & div:first-child {
    width: 30%;
    min-width: min(30%, 120px);
    //font-size: ${(props) => (props.chatFontSize > 0 ? `${.6 + Number(`.${props.chatFontSize}`)}em` : '.8em')};
    padding: 2px;
    text-overflow: ellipsis;
    background-color: ${(props) => (props.isSeller ? '#e0ddcd' : '#eee')};
    border-radius: 3px;
    margin-right: 5px;
  }
  & div:last-child {
    width: 70%;
    max-width: calc(100% - 120px);
    text-align: right;
  }
`;
